import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { upperFirst } from 'lodash-es';
import { PictogramSearching } from '@care/react-embrace-icons';
import {
  setPagePropertiesFromData,
  setDeviceDataFromHeaders,
  trackAmplitudeEvent,
  AmplitudeEvent,
} from '@/lib/analyticsHelper';
import { ScreenName, ScreenTemplate, TealiumSlot } from '@/constants';
import { usePageAttributes } from '@/components/contexts/PageAttributesContext';

export const NoSearchResults = () => {
  const { seoPageId, serviceIdForMember, deviceChar, pageType } = usePageAttributes();

  useEffect(() => {
    const pageProperties = {
      screen_name: ScreenName.SEGMENTATION,
      screen_template: ScreenTemplate.SEGMENTATION,
      seo_page_id: Number(seoPageId),
      service_id_for_member: serviceIdForMember,
      slots: TealiumSlot.VISITOR,
    };
    if (deviceChar && Object.keys(deviceChar).length > 0) {
      setPagePropertiesFromData(pageProperties);
      setDeviceDataFromHeaders(deviceChar);
    }

    const errorViewedData = {
      seo_page_type: upperFirst(pageType?.toLowerCase()),
      error_description: 'SEO no results',
      service_id_for_member: serviceIdForMember,
    };

    trackAmplitudeEvent(AmplitudeEvent.errorViewed, errorViewedData);
  }, [deviceChar, pageType, seoPageId, serviceIdForMember]);

  return (
    <Box px={{ xs: 3, sm: 0 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'background.default',
          borderRadius: { xs: 6, sm: 8 },
          px: 4,
          py: 6,
        }}>
        <PictogramSearching size={128} sx={{ mb: 3 }} />
        <Typography variant="h3" textAlign="center">
          No matches within your search
        </Typography>
        <Typography variant="body2" textAlign="center">
          Try changing your filters to see more results.
        </Typography>
      </Box>
    </Box>
  );
};
